import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
import AbstractStore from '../store/AbstractStore';
import RootStore from '../store/RootStore';
import { PickByType } from '../types/common-types';

export const useStore = (): PickByType<RootStore, AbstractStore> =>
  useContext(MobXProviderContext) as PickByType<RootStore, AbstractStore>;
